import React from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material';
import { accessType } from '../../lib/enums';

type Props = SelectProps & {
  helperText: any;
};
const AccessSelect = (props: Props) => {
  return (
    <>
      <FormControl fullWidth size="small" error={Boolean(props.helperText)}>
        <InputLabel id="access-select">Доступы</InputLabel>
        <Select
          labelId="access-select"
          id="access-select"
          multiple
          label="Доступы"
          {...props}
        >
          {Object.keys(accessType).map((key) => {
            return (
              <MenuItem value={key}>
                {/* @ts-ignore */}
                {accessType[key]}
              </MenuItem>
            );
          })}
        </Select>
        {props.helperText && (
          <FormHelperText>{props.helperText}</FormHelperText>
        )}
      </FormControl>
    </>
  );
};
export default AccessSelect;
